const doc = [({"da":({"js":({"nemoa":({"activities":({"required_metadata_proxy_with_surveys":({"save_and_continue_registration":"Gem og fortsæt tilmelding"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;